// extracted by mini-css-extract-plugin
export default {"root":"RobinDrawer_root__pHchX","close":"RobinDrawer_close__Bl4Tr","commission-account":"RobinDrawer_commission-account__u5bgM","help":"RobinDrawer_help__oACuv"};